import {
  Box,
  Checkbox,
  FormControl,
  FormErrorMessage,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PersonalDetailsFormValues } from "./personal-details";

type Props = {
  showUnderageTerms?: boolean;
};

export const TermsForm = ({ showUnderageTerms = false }: Props) => {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors, isSubmitted },
  } = useFormContext<PersonalDetailsFormValues>();
  const showErrors = isSubmitted;

  return (
    <VStack spacing={3} w="full">
      <FormControl isInvalid={showErrors && !!errors.healthTerms} isRequired>
        <Box bg="slate.50" borderRadius="10px" p={4}>
          <Checkbox
            alignItems="flex-start"
            spacing={3}
            sx={{ ".chakra-checkbox__control": { mt: "2px" } }}
            {...register("healthTerms")}
          >
            <Text fontSize="16px" textAlign="start" lineHeight="1.5" color="slate.600">
              {showUnderageTerms
                ? t("personalDetails.terms.underageHealthTerms")
                : t("personalDetails.terms.healthTerms")}
            </Text>
          </Checkbox>
        </Box>
        {showErrors && errors.healthTerms?.message && (
          <FormErrorMessage>{errors.healthTerms.message}</FormErrorMessage>
        )}
      </FormControl>
      {showUnderageTerms && (
        <FormControl isInvalid={showErrors && !!errors.underageTerms} isRequired>
          <Box bg="white" borderWidth="1px" borderColor="slate.200" borderRadius="10px" p={4}>
            <Checkbox
              alignItems="flex-start"
              spacing={3}
              sx={{ ".chakra-checkbox__control": { mt: "2px" } }}
              {...register("underageTerms")}
            >
              <Text fontSize="16px" textAlign="start" lineHeight="1.5" color="slate.600">
                {t("personalDetails.terms.underageTerms")}
              </Text>
            </Checkbox>
          </Box>
          {showErrors && errors.underageTerms?.message && (
            <FormErrorMessage>{errors.underageTerms.message}</FormErrorMessage>
          )}
        </FormControl>
      )}
    </VStack>
  );
};
